import './dsCSS.css';
import DataScience from './DataScience';

export default function DS() {
    return (
        <body className = 'white-background'>
        
                <DataScience />
        
        </body>
    )
}

